// import stringToHTML helper functions
import { stringToHTML } from 'utilities';

// import section style
import './style.scss';

// import template
const _template = require('./tmpl.html?template').default,
  _template_content = stringToHTML(_template).firstChild;

// Add section to body
document.body.append(_template_content);

// Map pins helper function
function updatePinPositions() {
  const mapContainer = document.getElementById('map-container');
  const mapSvg = document.getElementById('map-svg');

  // Get bounding box of the SVG path
  const boundingBox = mapSvg.getBoundingClientRect();

  // Set bounding box to the SVG
  mapContainer.style.setProperty('--map-width', boundingBox.width);
  mapContainer.style.setProperty('--map-height', boundingBox.height);
}

// Ensure the function runs on page load
document.addEventListener('DOMContentLoaded', updatePinPositions);

// Add a resize listener
window.addEventListener('resize', updatePinPositions);
